import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const technicianApi = createApi({
    reducerPath: "technicianApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["Technician"],
    endpoints: (builder) => ({
        getAllTechnicians: builder.query({
            query: ({ pageno, search,role ,userType ,limit , sortOrder , sortBy}) => {
                let url = `/${userType}/technicians?pageno=${pageno}`;
                if(limit){
                    url += `&limit=${limit}`;
                }
                if (search) {
                    url += `&search=${search}`;
                }
                if(role){
                    url += `&role=${role}`;
                }
                if(sortOrder){  
                    url += `&sortOrder=${sortOrder}`;
                }
                if(sortBy){
                    url += `&sortBy=${sortBy}`;
                }
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ["Technician"],
        }),
        addTechnician: builder.mutation({
            query: (data) => ({
                url: `/contractor/technician`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Technician"],
        }),
        updateTechnician: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/technician/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Technician"],
        }),
        deleteTechnician: builder.mutation({
            query: (id) => ({
                url: `/contractor/technicians/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Technician"],
        }),
        getTechnicianById: builder.query({
            query: ({id, userType}) => ({
                url: `/${userType}/technician/${id}`,
                method: "GET",
            }),
            providesTags: ["Technician"],
        }),
        getTechnicianInvoiceHistory: builder.query({
            query:({id ,status})=>({
                url:`/contractor/technician/${id}/invoice_history?status=${status}`,
                method:"GET"
            })
        })
    }),
});

export const {
    useGetAllTechniciansQuery,
    useAddTechnicianMutation,
    useUpdateTechnicianMutation,
    useDeleteTechnicianMutation,
    useGetTechnicianByIdQuery,
    useGetTechnicianInvoiceHistoryQuery,
} = technicianApi;